import { isValidCPF } from "@brazilian-utils/brazilian-utils";

/**
 * Valida CPF utilizando a biblioteca brazilian-utils.
 */
export function ValidateCPF(cpfInput: string): boolean {
  const cpf = cpfInput?.replace(/\D/g, "");

  if (!cpf || cpf.length !== 11) return false;

  return isValidCPF(cpf);
}
